<template>
    <div class="bg-gray-200 p-8 min-h-screen">
        <h3 class="text-lg font-medium text-gray-800 flex w-full">
            <svg class="h-6 w-6 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div class="ml-4 flex-1">
                {{ _("You already placed an order at") }}  {{ restaurant.name }}
            </div>
        </h3>
        
        <div v-for="delivery in deliveries" class="bg-white p-4 shadow mt-8">
            <div class="flex w-full">
                <div class="flex-1">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {{ status_name }}
                    </span>
                </div>
                <div>#{{ delivery.order_id}}</div>
                
            </div>


            <div class="text-gray-600 mt-4">
                <svg class="inline-block w-4 h-4 mr-1 stroke-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>

                {{ delivery.customer_address }}
            </div>
            

            <div class="my-6">
                <div class="w-full flex items-start border-b border-gray-200" v-for="(row, index) in delivery.order.details" :key="index">

                    <div class="flex-1 mr-2">
                        {{ row.submission_title }} x {{ row.qnty }}
                        <div class="text-sm text-gray-500" v-if="!row.v2">
                            <div v-for="line in row.remarks.split('\n')">
                                {{ line }}
                            </div>
                        </div>
                    </div>
                    <div>${{ row.submission_total.toFixed(2) }}</div>
                </div>
            </div>


            <div class="mb-6">
                <div class="w-full flex items-start " v-if="delivery.order.discount">

                    <div class="flex-1 text-right mr-2 font-bold">
                        {{ _("Discount")}}
                    </div>
                    <div class="w-1/4 text-right">${{ delivery.order.discount ? delivery.order.discount.toFixed(2) : 0.0 }}</div>
                </div>

                <div class="w-full flex items-start ">

                    <div class="flex-1 text-right mr-2 font-bold">
                        {{ _("Subtotal")}}
                    </div>
                    <div class="w-1/4 text-right">${{ delivery.order.sub_total.toFixed(2) }}</div>
                </div>

                <div class="w-full flex items-start ">

                    <div class="flex-1 text-right mr-2 font-bold">
                        {{ _("GST")}}
                    </div>
                    <div class="w-1/4 text-right">${{ delivery.order.gst.toFixed(2) }}</div>
                </div>

                <div class="w-full flex items-start ">

                    <div class="flex-1 text-right mr-2 font-bold">
                        {{ _("QST")}}
                    </div>
                    <div class="w-1/4 text-right">${{ delivery.order.qst.toFixed(2) }}</div>
                </div>

                <div class="w-full flex items-start mt-2">

                    <div class="flex-1 text-right mr-2 font-bold">
                        {{ _("Total")}}
                    </div>
                    <div class="w-1/4 text-right">${{ delivery.order.grand_total.toFixed(2) }}</div>
                </div>

            </div>
            
            
            
        </div>


        <div class="my-8">
            <inertia-link :href="$route('user.menu', {customer: customer.id, restaurant: restaurant.id, skip_order_check: true, ...extras})" class="block w-full text-center px-4 py-4 border border-transparent text-base font-medium rounded-md text-white bg-gray-500">
                {{ _("Place another order") }}
            </inertia-link>

        </div>
        
    </div>
</template>

<script>

import {lang} from "../../lang";

export default {
  name: "ExistingDelivery",
    props: ['restaurant', 'customer', 'deliveries', 'extras', 'status_name'],
    components: {},
    data() {
        return {
            app_locale: this.extras['app_locale'],
           

        }
    },
    methods: {

        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
        
        
    }
    
}
</script>

<style scoped>

</style>
